export default "__VITE_ASSET__DIY1iPsv__"